import { Component } from 'react';
import { compose } from 'recompose';
import { ChartFragment, Section } from 'models/api-response';
import { FormFieldInputType } from 'models/enum';
import { ChartActionsComponentProps, ChartComponentProps, ChartMetaFormField } from 'models/ui';
import { chartHelper } from 'helpers';
import { chartService } from 'services';
import { withChartLogic } from 'components/common';
import { ChartViewProps } from 'components/features/shared/constants';
import withSavedPatientChartsPage from 'components/features/shared/withSavedPatientChartsPage';
import { FormField, SectionTitle } from './constants';
import SafetyInterventionsView from './SafetyInterventionsView';
import { Title } from '../shared/constants';

class SafetyInterventions extends Component<ChartComponentProps> {
  static displayName = 'SafetyInterventions';

  componentDidMount() {
    this.props.initState(this.buildDefaultFormFields());
  }

  buildDefaultFormFields = (): Map<string, ChartMetaFormField> => {
    const { createFormField } = chartHelper;
    const dataMap = new Map();

    const checkBoxes = [FormField.NO_CARE_REQUIRED];
    const multiselectDropdowns = [FormField.SAFETY_ISSUES, FormField.PATIENT_RESPONSE];

    const textAreas = [FormField.CARE_NOTES];
    checkBoxes.forEach((name) => dataMap.set(name, createFormField({ name, type: FormFieldInputType.CHECK_BOX })));
    multiselectDropdowns.forEach((name) => dataMap.set(name, createFormField({ name, type: FormFieldInputType.MULTISELECT_DROPDOWN })));
    textAreas.forEach((name) => dataMap.set(name, createFormField({ name, type: FormFieldInputType.TEXT_AREA })));

    return dataMap;
  };

  createSections = (): Section[] => {
    const { formFieldMap } = this.props;
    return [
      chartHelper.buildSection({ sectionTitle: SectionTitle.SAFETY_INTERVENTIONS, fields: [FormField.NO_CARE_REQUIRED], formFieldMap }),
      chartHelper.buildSection({
        sectionTitle: SectionTitle.SAFETY_ISSUES,
        fields: [FormField.SAFETY_ISSUES],
        formFieldMap
      }),
      chartHelper.buildSection({
        sectionTitle: SectionTitle.PATIENT_RESPONSE,
        fields: [FormField.PATIENT_RESPONSE],
        formFieldMap
      }),
      chartHelper.buildSection({
        sectionTitle: SectionTitle.CARE_NOTES,
        fields: [FormField.CARE_NOTES],
        formFieldMap
      })
    ];
  };

  buildFragment = () => {
    const record = {
      chartTitle: Title.SYSTEM_NURSING_INTERVENTIONS,
      fragmentTitle: SectionTitle.SAFETY_INTERVENTIONS,
      records: this.createSections()
    };
    const cleanRecord = chartService.systemAssessment.removeEmptyRecords(record);
    const basicInfo = chartService.createBaseFragment({ chartingTime: this.props.chartingTime });
    return { ...basicInfo, chartData: cleanRecord } as ChartFragment;
  };

  handleSaveClick = () => {
    this.props.saveChart([this.buildFragment()], { afterSave: this.props.navigateToSavedPatientCharting });
  };

  render() {
    const chartActionsProps: ChartActionsComponentProps = {
      enableDisplayRecordsButton: this.props.enableDisplayRecordsButton,
      enableSaveButton: this.props.hasUnsavedChanges,
      onDisplayRecordsClick: this.props.displayAuthoringData,
      onSaveClick: this.handleSaveClick,
      onCancelClick: () => this.props.handleDiscardClick(undefined, this.buildDefaultFormFields())
    };
    const viewProps: ChartViewProps = {
      chartActionsProps,
      formFieldMap: this.props.formFieldMap,
      formSubmittedCount: this.props.formSubmittedCount
    };
    return <SafetyInterventionsView {...viewProps} />;
  }
}

export { SafetyInterventions as BaseSafetyInterventions };
export default compose(withSavedPatientChartsPage, withChartLogic)(SafetyInterventions);
